import React from 'react';
import CatalogPage from '@/pages/CatalogPage';

export default function App() {
  return <CatalogPage />;
}
